import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-upload-image-warning-modal',
  templateUrl: './upload-image-warning-modal.component.html',
  styleUrls: ['./upload-image-warning-modal.component.scss']
})
export class UploadImageWarningModalComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  @Input() public minWidth;
  @Input() public minHeight;
  ngOnInit() {
  }
  closeDialog(){
    this.activeModal.close();
  }

}
